module.exports = __webpack_public_path__ + "media/images/flags/za-83099da26ad6804ed7a59dfb9b639de0.svg";